import { computed, defineComponent } from 'vue'
import { useNamespace } from '@xzx-design/hooks'
import { tabTitleProps } from './types/tab-title'

import type { CSSProperties } from 'vue'

export const TabTitle = defineComponent({
  props: tabTitleProps,
  setup(props, { slots }) {
    const { b, e, em, m } = useNamespace('tab')

    // const props = defineProps(tabTitleProps)
    // const slots = useSlots()

    const style = computed(() => {
      const style: CSSProperties = {}
      const { type, color, disabled, isActive, activeColor, inactiveColor } =
        props

      const isCard = type === 'card'

      // card theme color
      if (color && isCard) {
        style.borderColor = color

        if (!disabled) {
          if (isActive) {
            style.backgroundColor = color
          } else {
            style.color = color
          }
        }
      }

      const titleColor = isActive ? activeColor : inactiveColor
      if (titleColor) {
        style.color = titleColor
      }

      return style
    })

    const renderText = () => {
      const Text = (
        // bem('text', { ellipsis: !props.scrollable })
        <span class={[e('text'), !props.scrollable && em('text', 'ellipsis')]}>
          {slots.title ? slots.title() : props.title}
        </span>
      )

      // if (props.dot || (isDef(props.badge) && props.badge !== '')) {
      //   return (
      //     <Badge
      //       dot={props.dot}
      //       content={props.badge}
      //       showZero={props.showZeroBadge}
      //     >
      //       {Text}
      //     </Badge>
      //   )
      // }

      return Text
    }

    return () => (
      <div
        id={props.id}
        role="tab"
        class={[
          b(),
          m(props.type),
          props.scrollable && !props.shrink && m('grow'),
          props.shrink && m('shrink'),
          props.isActive && m('active'),
          props.disabled && m('disabled'),
        ]}
        style={style.value}
        tabindex={props.disabled ? undefined : props.isActive ? 0 : -1}
        aria-selected={props.isActive}
        aria-disabled={props.disabled || undefined}
        aria-controls={props.controls}
        data-allow-mismatch="attribute"
      >
        {renderText()}
      </div>
    )
  },
})
